export enum EPeriodTickets {
  FUTURE = 'FUTURE',
  PAST = 'PAST',
};



export default EPeriodTickets;
